export default __webpack_public_path__ + "static/media/FaqLight.979f0aa3.svg";